"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/config.js"));

var _KESI2Helper = _interopRequireDefault(require("../../../../KESI2/KESI2Helper"));

var _HtmlNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/HtmlNugget"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _CourseLoader = _interopRequireDefault(require("../../../../helpers/CourseLoader"));

var _UrlNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/UrlNugget"));

var _PreconditionChecker = require("../../../../utils/PreconditionChecker");

/*************
 * Standard Home Course Layout
 * {
  "pages": [],
  "rev": "1.2",
  "v": "112",
  "title": "equeo Quiz",
  "desc": "equeo Quiz course",
  "keywords": "",
  "type": "",
  "feature": "",
  "id": "O2ZDoqSvR2ywnkXHSzb4ow",
  "courseid": "",
  "header": "",
  "parent": "",
  "published": "2019-09-05 14:16:42",
  "lastUpdated": "2019-09-05 14:11:57",
  "inheritedTypes": [],
  "chapters": []
}

 img Element:
 "type": "img",
 "v": "3",
 "src": "#media://Ai67iGjqSrK9NGJkZQAb4w_QD_Header_neu.png",
 "id": "O4peXgHyS-WKpta_eitN7w"

 html Element:
 "type": "com.equeo.player.ext.html.Html",
 "v": "5",
 "id": "KK6JPa5HQuuBCu5d-4oKMA",
 "style": "",
 "content": "html"
 */
var DrupalToEMSHelper = /*#__PURE__*/function () {
  function DrupalToEMSHelper() {
    (0, _classCallCheck2["default"])(this, DrupalToEMSHelper);
    this.bla = null;
  }

  (0, _createClass2["default"])(DrupalToEMSHelper, [{
    key: "translateDrupalContentToEMSContent",
    value: function () {
      var _translateDrupalContentToEMSContent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var courseData, mockedHomeCourse;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _KESI2Helper["default"].getAllCourseData();

              case 2:
                courseData = _context.sent;
                mockedHomeCourse = {
                  pages: [],
                  rev: '1.0',
                  v: '10',
                  title: courseData && courseData.length > 0 ? courseData[0].title : 'undefined',
                  id: courseData && courseData.length > 0 ? courseData[0].id : 423,
                  chapters: [],
                  lastUpdated: (0, _now["default"])(),
                  inheritedTypes: [],
                  header: courseData && courseData.length > 0 ? courseData[0].background : null,
                  feature: ''
                };

                if (!(courseData && courseData.length > 0)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.HOMECOURSE_ID, courseData[0].id);

              case 7:
                if (courseData[0].spocs && courseData[0].spocs.length > 0) {
                  courseData[0].spocs.forEach(function (spoc) {
                    if (spoc) {
                      var spocChapter = {
                        pages: [{
                          elements: [],
                          v: '1',
                          name: spoc.title,
                          id: spoc.id,
                          desc: '',
                          type: '',
                          feature: '',
                          keywords: '',
                          lastUpdated: (0, _now["default"])(),
                          inheritedTypes: []
                        }],
                        rev: '1.0',
                        v: '1',
                        title: spoc.title,
                        id: spoc.id,
                        chapters: [],
                        header: spoc.background,
                        lastUpdated: (0, _now["default"])(),
                        type: spoc.keyword ? spoc.keyword : '',
                        inheritedTypes: [],
                        showPrecondition: spoc.showPrecondition,
                        feature: ''
                      };

                      if (spoc.lectures && spoc.lectures.length > 0) {
                        spoc.lectures.forEach(function (lecture) {
                          if (lecture) {
                            var chapter = {
                              pages: [],
                              rev: '1.0',
                              v: '1',
                              title: lecture.title,
                              id: lecture.id,
                              chapters: [],
                              header: lecture.background,
                              lastUpdated: (0, _now["default"])(),
                              type: lecture.keyword ? lecture.keyword : '',
                              inheritedTypes: [],
                              showPrecondition: lecture.showPrecondition,
                              feature: ''
                            };
                            var defaultPage = {
                              elements: [],
                              v: '1',
                              name: lecture.title,
                              id: lecture.id,
                              desc: '',
                              type: '',
                              feature: '',
                              keywords: lecture.keyword ? lecture.keyword : '',
                              lastUpdated: (0, _now["default"])(),
                              inheritedTypes: []
                            };

                            if (lecture.nuggetIds && lecture.nuggetIds.length > 0) {
                              lecture.nuggetIds.forEach(function (nuggetId, index) {
                                var nugget = _KESI2Helper["default"].getContentById(nuggetId);

                                if (nugget && nugget.showPrecondition) {
                                  console.log('checking nugget ' + nugget.title + ' with precondition');
                                  var failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(nugget.showPrecondition);

                                  if (failingPrecondition) {
                                    console.log('removed nugget ' + nugget.title + ' because of failing precondition');
                                    return;
                                  }
                                }

                                if (nugget) {
                                  if (nugget && nugget instanceof _HtmlNugget["default"]) {
                                    var element = {
                                      type: 'com.equeo.player.ext.html.Html',
                                      id: nugget.id,
                                      content: nugget.template,
                                      showPrecondition: nugget.showPrecondition
                                    };

                                    _CourseLoader["default"].addDrupalContentToLocalVars(element.id, element);

                                    var currentPage = JSON.parse((0, _stringify["default"])(defaultPage));
                                    currentPage.elements.push(element);
                                    chapter.pages.push(currentPage); // chapter.pages[index].elements.push(element)
                                  } else if (nugget && nugget instanceof _UrlNugget["default"]) {
                                    chapter.keywords = nugget.src;
                                  }
                                }
                              });
                            }

                            _CourseLoader["default"].addDrupalContentToLocalVars(chapter.id, chapter);

                            spocChapter.chapters.push(chapter);
                          }
                        });
                      }

                      _CourseLoader["default"].addDrupalContentToLocalVars(spocChapter.id, spocChapter);

                      mockedHomeCourse.chapters.push(spocChapter);
                    }
                  });
                }

                _CourseLoader["default"].addDrupalContentToLocalVars(mockedHomeCourse.id, mockedHomeCourse);

              case 9:
                return _context.abrupt("return", mockedHomeCourse);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function translateDrupalContentToEMSContent() {
        return _translateDrupalContentToEMSContent.apply(this, arguments);
      }

      return translateDrupalContentToEMSContent;
    }()
  }, {
    key: "translateDrupalContentToEMSContentWithId",
    value: function () {
      var _translateDrupalContentToEMSContentWithId = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(id) {
        var content, mockedCourse;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                content = _KESI2Helper["default"].getContentById(id);
                mockedCourse = {
                  pages: [{
                    elements: [],
                    v: '1',
                    name: content.title,
                    id: content.id,
                    desc: '',
                    type: '',
                    feature: '',
                    keywords: '',
                    lastUpdated: (0, _now["default"])(),
                    inheritedTypes: []
                  }],
                  rev: '1.0',
                  v: '10',
                  title: content.title,
                  id: content.id,
                  chapters: [],
                  header: content.background,
                  lastUpdated: (0, _now["default"])(),
                  type: content.keyword ? content.keyword : '',
                  inheritedTypes: [],
                  showPrecondition: content.showPrecondition,
                  feature: ''
                };

                if (content) {
                  if (content.spocs && content.spocs.length > 0) {
                    content.spocs.forEach(function (spoc) {
                      var spocChapter = {
                        pages: [{
                          elements: [],
                          v: '1',
                          name: spoc.title,
                          id: spoc.id,
                          desc: '',
                          type: '',
                          feature: '',
                          keywords: '',
                          lastUpdated: (0, _now["default"])(),
                          inheritedTypes: []
                        }],
                        rev: '1.0',
                        v: '1',
                        title: spoc.title,
                        id: spoc.id,
                        chapters: [],
                        header: spoc.background,
                        lastUpdated: (0, _now["default"])(),
                        type: spoc.keyword ? spoc.keyword : '',
                        inheritedTypes: [],
                        showPrecondition: spoc.showPrecondition
                      };

                      if (spoc.lectures && spoc.lectures.length > 0) {
                        spoc.lectures.forEach(function (lecture) {
                          var chapter = {
                            pages: [],
                            rev: '1.0',
                            v: '1',
                            title: lecture.title,
                            id: lecture.id,
                            chapters: [],
                            header: lecture.background,
                            lastUpdated: (0, _now["default"])(),
                            type: lecture.keyword ? lecture.keyword : '',
                            inheritedTypes: [],
                            showPrecondition: lecture.showPrecondition,
                            feature: ''
                          };
                          var defaultPage = {
                            elements: [],
                            v: '1',
                            name: lecture.title,
                            id: lecture.id,
                            desc: '',
                            type: '',
                            feature: '',
                            keywords: '',
                            lastUpdated: (0, _now["default"])(),
                            inheritedTypes: []
                          };

                          if (lecture.nuggetIds && lecture.nuggetIds.length > 0) {
                            lecture.nuggetIds.forEach(function (nuggetId, index) {
                              var nugget = _KESI2Helper["default"].getContentById(nuggetId);

                              if (nugget && nugget.showPrecondition) {
                                console.log('checking nugget ' + nugget.title + ' with precondition');
                                var failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(nugget.showPrecondition);

                                if (failingPrecondition) {
                                  console.log('removed nugget ' + nugget.title + ' because of failing precondition');
                                  return;
                                }
                              }

                              if (nugget && nugget instanceof _HtmlNugget["default"]) {
                                var element = {
                                  type: 'com.equeo.player.ext.html.Html',
                                  id: nugget.id,
                                  content: nugget.template,
                                  showPrecondition: nugget.showPrecondition
                                };

                                _CourseLoader["default"].addDrupalContentToLocalVars(element.id, element);

                                var currentPage = JSON.parse((0, _stringify["default"])(defaultPage));
                                currentPage.elements.push(element);
                                chapter.pages.push(currentPage); // chapter.pages[index].elements.push(element)
                              } else if (nugget && nugget instanceof _UrlNugget["default"]) {
                                chapter.keywords = nugget.src;
                              }
                            });
                          }

                          console.log('drupaltoems2', chapter, lecture);

                          _CourseLoader["default"].addDrupalContentToLocalVars(chapter.id, chapter);

                          spocChapter.chapters.push(chapter);
                        });
                      }

                      console.log('drupaltoems3', spocChapter, spoc);

                      _CourseLoader["default"].addDrupalContentToLocalVars(spocChapter.id, spocChapter);

                      mockedCourse.chapters.push(spocChapter);
                      console.log('mockedHomeCourse spoc chapter added', spocChapter);
                    });
                  }

                  if (content.lectures && content.lectures.length > 0) {
                    content.lectures.forEach(function (lecture) {
                      var chapter = {
                        pages: [{
                          elements: [],
                          v: '1',
                          name: lecture.title,
                          id: lecture.id,
                          desc: '',
                          type: '',
                          feature: '',
                          keywords: '',
                          lastUpdated: (0, _now["default"])(),
                          inheritedTypes: []
                        }],
                        rev: '1.0',
                        v: '1',
                        title: lecture.title,
                        id: lecture.id,
                        chapters: [],
                        header: lecture.background,
                        lastUpdated: (0, _now["default"])(),
                        type: lecture.keyword ? lecture.keyword : '',
                        inheritedTypes: [],
                        showPrecondition: lecture.showPrecondition,
                        feature: ''
                      };

                      if (lecture.nuggetIds && lecture.nuggetIds.length > 0) {
                        lecture.nuggetIds.forEach(function (nuggetId, index) {
                          var nugget = _KESI2Helper["default"].getContentById(nuggetId);

                          if (nugget && nugget.showPrecondition) {
                            console.log('checking nugget ' + nugget.title + ' with precondition');
                            var failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(nugget.showPrecondition);

                            if (failingPrecondition) {
                              console.log('removed nugget ' + nugget.title + ' because of failing precondition');
                              return;
                            }
                          }

                          if (nugget && nugget instanceof _HtmlNugget["default"]) {
                            var element = {
                              type: 'com.equeo.player.ext.html.Html',
                              id: nugget.id,
                              content: nugget.template,
                              showPrecondition: nugget.showPrecondition
                            };

                            _CourseLoader["default"].addDrupalContentToLocalVars(element.id, element);

                            chapter.pages[index].elements.push(element);
                          } else if (nugget && nugget instanceof _UrlNugget["default"]) {
                            chapter.keywords = nugget.src; // chapter.pages[0].type = 'equeo_external_website'
                          }
                        });
                      }

                      _CourseLoader["default"].addDrupalContentToLocalVars(chapter.id, chapter);

                      mockedCourse.chapters.push(chapter);
                    });
                  }

                  if (content.nuggetIds && content.nuggetIds.length > 0) {
                    content.nuggetIds.forEach(function (nuggetId, index) {
                      var nugget = _KESI2Helper["default"].getContentById(nuggetId);

                      if (nugget && nugget.showPrecondition) {
                        console.log('checking nugget ' + nugget.title + ' with precondition');
                        var failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(nugget.showPrecondition);

                        if (failingPrecondition) {
                          console.log('removed nugget ' + nugget.title + ' because of failing precondition');
                          return;
                        }
                      }

                      if (nugget && nugget instanceof _HtmlNugget["default"]) {
                        mockedCourse.elements.push({
                          type: 'com.equeo.player.ext.html.Html',
                          id: nugget.id,
                          content: nugget.template,
                          showPrecondition: nugget.showPrecondition
                        });
                      } else if (nugget && nugget instanceof _UrlNugget["default"]) {
                        mockedCourse.keywords = nugget.src;
                      }
                    });
                  }
                }

                _CourseLoader["default"].addDrupalContentToLocalVars(mockedCourse.id, mockedCourse);

                return _context2.abrupt("return", mockedCourse);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function translateDrupalContentToEMSContentWithId(_x) {
        return _translateDrupalContentToEMSContentWithId.apply(this, arguments);
      }

      return translateDrupalContentToEMSContentWithId;
    }()
  }]);
  return DrupalToEMSHelper;
}();

var instance = new DrupalToEMSHelper();
var _default = instance;
exports["default"] = _default;